import { getRandomNum, randomString } from './tool'
import _storage from '@/utils/storage'
import { LocalStorageKey } from '@/constant'

/**
 * 获取浏览器id
 */
export function getBrowserId() {
  let browserId = _storage.get(LocalStorageKey.BROWSER_ID) || ''
  if (browserId) return browserId

  browserId = randomString(24) + getRandomNum(10000000, 99999999)
  _storage.set(LocalStorageKey.BROWSER_ID, browserId)
  return browserId
}

/**
 * 设置浏览器id
 */
export function setBrowserId() {
  if (!_storage.get(LocalStorageKey.BROWSER_ID)) {
    const browserId = randomString(24) + getRandomNum(10000000, 99999999)
    _storage.set(LocalStorageKey.BROWSER_ID, browserId)
  }
}
